"use strict";

import _ from "lodash";
import React from "react";
import { Link } from "react-router";
import moment from "moment";

class Recent_Event extends React.Component {
  constructor(props) {
    super(props);
  }

  renderDate = (city, format, isMultiCity) => {
    let fmt = format ? format : "MMM. D, YYYY";
    if (!city)
      return moment
        .unix(city.date)
        .utcOffset("+0500")
        .format(fmt);

    return !format && city.end && city.start !== city.end
      ? [
          [
            moment
              .unix(city.start)
              .utcOffset("+0500")
              .format("MMM. D"),
            moment
              .unix(city.end)
              .utcOffset("+0500")
              .format("D, YYYY")
          ].join("-"), city.city
        ].join((isMultiCity ? ", " : " • "))
      : [
          moment
            .unix(city.start)
            .utcOffset("+0500")
            .format(fmt), city.city
        ].join((isMultiCity ? ", " : " • "));
  };

  render() {
    let eventLink = this.props.event.name
      ? "/conference/" +
        this.props.event.conference_id +
        "/" +
        this.props.event.year
      : this.props.event.link;

    let marketingImg = this.props.event.marketing_img
      ? "/" + this.props.event.marketing_img
      : null;

    let summaryDesc = this.props.event.summary
      ? this.props.event.summary
      : this.props.event.description;
    
    let charLimit = this.props.charLimit ? this.props.charLimit : null;
    let summaryText = summaryDesc;

    // kicker string for webinars, example: "ORIGINALLY AIRED • MARCH 27, 2019"
    let kickerString = '';
    if (this.props.eventType == 'webinar') {
      let kickerStringDate = moment.unix(this.props.event.date).format("MMM. D, YYYY");
      kickerString = 'Originally Aired • ' + kickerStringDate;
    }
    
    if (charLimit != null && summaryDesc.length >= charLimit) {
      summaryText = summaryDesc.replace(/<[^>]+>/g, '').substring(0, charLimit);
      summaryText = summaryText.substr(0, Math.min(summaryText.length, summaryText.lastIndexOf(" ")));
      summaryText = summaryText + "...";
    } 
  
    let boxClass = 'recent-conference';
    let countIndex = this.props.countIndex ? this.props.countIndex : null;
    if (countIndex != null) {
      if(countIndex % 3 === 2) {
        boxClass += ' no-right-border';
      } 
    }
    
    return (
      <div className={boxClass}>
        {_.size(this.props.event.cities) > 1 ? (
          <span key={this.props.event.cities[0]._id}>
            {this.props.event.cities[0].on_demand ? "On Demand" : this.props.event.cities[0].tbd ? "TBD" : this.renderDate(this.props.event.cities[0], null, true)}
          </span>
        ) : (
          _.map(this.props.event.cities, city => {
            return <span key={city._id}>{city.on_demand ? "On Demand" : city.tbd ? "TBD" : this.renderDate(city)}</span>;
          })
        )}
        
        {kickerString ? (
          <span>{kickerString}</span>
        ) : null}
       
        {eventLink ? (
          <h4>
            <a href={eventLink}>
              {this.props.event.name
                ? this.props.event.name
                : this.props.event.title}
            </a>
          </h4>
        ) : null}

        {!summaryDesc ? null : (
          <p
            itemProp="description"
            dangerouslySetInnerHTML={{ __html: summaryText }}
          />
        )}
      </div>
    );
  }
}

export default Recent_Event;
